const _ = require('lodash')
module.exports = function pickChangedFields (original, updated) {
  return _.pickBy(updated, (value,key) =>  !_.isEqual(value, original[key]));
}
